/**
 * Per-thread stream state registry.
 *
 * Module-level singleton — persists across React renders and navigation so
 * the frontend can re-attach to a still-generating stream after switching threads.
 */

interface ThreadStreamState {
  /** Cursor from the 202 response — start of THIS stream (not the previous one). */
  streamStartCursor: string;
  /** Last successfully processed cursor. */
  cursor: string;
  done: boolean;
  error: string | null;
}

const registry = new Map<string, ThreadStreamState>();

export function initThreadStream(threadId: string, streamStartCursor: string): void {
  registry.set(threadId, {
    streamStartCursor,
    cursor: streamStartCursor,
    done: false,
    error: null,
  });
}

export function updateThreadStream(
  threadId: string,
  cursor: string,
  done: boolean,
  error: string | null,
): void {
  const existing = registry.get(threadId);
  if (existing) {
    existing.cursor = cursor;
    existing.done = done;
    existing.error = error;
  }
}

export function getThreadStream(threadId: string): ThreadStreamState | undefined {
  return registry.get(threadId);
}
